/* Browser-to-Worker transport shared with isolated tests; never contacts Klaviyo. */
(function (root) {
  const api = {
    async send(endpoint, payload, options = {}) {
      const request = options.fetch || root.fetch.bind(root);
      const Controller = options.AbortController || root.AbortController;
      const controller = new Controller();
      const timer = setTimeout(() => controller.abort(), options.timeout || 25000);
      try {
        const body = new URLSearchParams(payload);
        body.set('response_format', 'json');
        // URLSearchParams is a CORS simple request: no JSON preflight/cookies needed.
        const response = await request(endpoint, {method:'POST',body,credentials:'omit',signal:controller.signal});
        let result;
        try { result = await response.json(); }
        catch (_) { return {ok:false,uncertain:true,code:'unreadable_response'}; }
        return response.ok && result && result.ok === true
          ? {ok:true}
          : {ok:false,uncertain:response.status>=500,code:result && result.error || 'rejected'};
      } catch (error) {
        return {ok:false,uncertain:true,code:error.name === 'AbortError' ? 'timeout' : 'network'};
      } finally { clearTimeout(timer); }
    }
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.BarbasSignupTransport = api;
})(typeof window !== 'undefined' ? window : globalThis);
